import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfTareas } from '@/modules/Core/interfaces'
import type { AxiosResponse } from 'axios'
export class TareaService extends BaseService<IConfTareas> {
  constructor () {
    super({
      baseUrl: 'system/jobs/'
    })
  }
  async getdownloadFile(
      uuid: string
    ): Promise<AxiosResponse<ArrayBuffer>> {
      return this.http.get<ArrayBuffer>(`/download/${uuid}`, {
        responseType: 'arraybuffer',
        headers: {
          'Access-Control-Max-Age': '0'
        }
      })
    } 
}
